export { urls } from "./urls"
export { State, reducer } from "./reducers"
export { saga } from "./sagas"
import * as Selectors from "./selectors"
import * as Actions from "./actions"
export { Selectors, Actions }
import component from "./components/EquityInjectionsData"
export default component